import Box, { Item } from "devextreme-react/box";
import Button from "devextreme-react/button";
import Popup, { ToolbarItem } from "devextreme-react/popup";
import RadioGroup from "devextreme-react/radio-group";
import { TextArea } from "devextreme-react/text-area";
import ValidationGroup from "devextreme-react/validation-group";
import ValidationSummary from "devextreme-react/validation-summary";
import Validator, { RequiredRule } from "devextreme-react/validator";
import { useContext, useState } from "react";
import { useGetLookupValuesByType } from "../../../../api/lookup";
import { LoadPopupPanel } from "../../../../components";
import { Field } from "../../../../layouts";
import { AR, QuoteStatus, QuoteTypes } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useCloseLead } from "../api/close-lead";
import { EstimateContext } from "../context/EstimateContext";

export default function CloseLeadButton() {

	const DEFAULT_REASON = 5400;
	const OTHER_REASON = 5408;

	const { order, refetchOrder } = useContext(EstimateContext);
	const [isPopupVisible, setPopupVisibility] = useState(false);
	const [selectedReason, setSelectedReason] = useState(DEFAULT_REASON);
	const [comment, setComment] = useState();
	const reasons = useGetLookupValuesByType('CloseLeadReason', isPopupVisible);

	const closeLead = useCloseLead(
		order.details.quoteID,
		selectedReason,
		comment,
		() => {
			setPopupVisibility(false);
			showSuccessMessage('Lead has been closed');
			refetchOrder();
		},
		(error) => showErrorMessage(error)
	)

	return (
		<>
			<Button
				text={order.details.quoteTypeID === QuoteTypes.Lead ? "Decline Appointment" : "Close Lead"}
				icon="Inscyth-Cancel"
				visible={
					(order.details.quoteTypeID === QuoteTypes.Lead || order.details.resolvedARs.includes(AR.LeadSubmitEstimate)) &&
					(order.details.statusID === QuoteStatus.Open || order.details.statusID === QuoteStatus.Hold)}
				onClick={() => { setPopupVisibility(true); }} >
			</Button>

			<ValidationGroup>
				<Popup
					title={order.details.quoteTypeID === QuoteTypes.Lead ? "SF&I Decline Appointment" : "Close Lead"}
					width={700}
					height={500}
					visible={isPopupVisible}
					hideOnOutsideClick={true}
					onHiding={() => setPopupVisibility(false)}
				>
					<ToolbarItem
						options={{
							icon: 'dx-icon dx-icon-close',
							onClick: function () {
								setPopupVisibility(false);
							}
						}}
						widget="dxButton"
						location="after"
					/>
					<ValidationSummary validationGroup="closeLeadGroup"></ValidationSummary>
					<Box>
						<Item baseSize={310}>
							<RadioGroup
								dataSource={reasons.data}
								valueExpr={'lookupID'}
								displayExpr={'displayValue'}
								value={selectedReason}
								onValueChanged={(e) => {
									setSelectedReason(e.value);
									if (e.value !== OTHER_REASON)
										setComment(undefined);
								}}
							/>
						</Item>
						<Item ratio={1}>
							<Field label={'Comment'}
								vertical={true}
								className="black-label"
								visible={selectedReason === OTHER_REASON}>
								<TextArea value={comment} height={250}
									onValueChanged={(e) => setComment(e.value)}>
									<Validator validationGroup="closeLeadGroup">
										<RequiredRule message={'Comment is required'} />
									</Validator>
								</TextArea>
							</Field>
						</Item>
					</Box>
					<ToolbarItem
						options={{
							type: 'normal',
							stylingMode: 'contained',
							text: 'Submit',
							validationGroup: 'closeLeadGroup',
							onClick: (e: any) => {
								if (!e.validationGroup || e.validationGroup.validate().isValid) {
									closeLead.mutate();
								}
							}
						}}
						toolbar={'bottom'}
						widget="dxButton"
						location="after"
					>
					</ToolbarItem>
					<ToolbarItem
						options={{
							type: 'normal',
							stylingMode: 'contained',
							text: 'Cancel',
							onClick: () => setPopupVisibility(false)
						}}
						toolbar={'bottom'}
						widget="dxButton"
						location="after"
					>
					</ToolbarItem>
					<LoadPopupPanel visible={reasons.isLoading || closeLead.isLoading}></LoadPopupPanel>
				</Popup>
			</ValidationGroup>
		</>
	)
}
